"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ServiceCounter = function ServiceCounter(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M19.808 13.25h-.287a.4.4 0 01-.372-.249l-1.105-2.78-.41 1.004a.307.307 0 00.038.274 7.238 7.238 0 011.202 3.923.317.317 0 01-.314.328h-1.228l-.299 4.085a.316.316 0 01-.318.29h-.68a.317.317 0 01-.318-.29l-.299-4.085H14.19a.317.317 0 01-.314-.328 7.238 7.238 0 011.202-3.923.307.307 0 00.038-.274l-.41-1.004-1.105 2.78a.399.399 0 01-.372.249h-.287a.314.314 0 01-.312-.38l.198-.87H3.875a.625.625 0 110-1.25h1.253V9.187c0-.862.7-1.562 1.563-1.562h3.118c.863 0 1.563.7 1.563 1.563v1.562h1.74l.376-1.657a1.908 1.908 0 011.87-1.468h2.033a1.908 1.908 0 011.871 1.468l.858 3.777a.314.314 0 01-.312.38zM16.375 7a1.563 1.563 0 110-3.125 1.563 1.563 0 010 3.125zM8.25 7a1.563 1.563 0 110-3.125A1.563 1.563 0 018.25 7z"
  }));
};

var _default = (0, _react.forwardRef)(ServiceCounter);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ServiceCounter, "ServiceCounter", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/ServiceCounter.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/ServiceCounter.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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